import BaseModelAPI from '../BaseModelAPI';

export default class DocumentAttachmentList extends BaseModelAPI {

	static entity = 'documentattachmentlist'
	static entityName = 'documentattachment';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
